import React from "react";
import { MenuItem } from "../components/Menu";
import { useAtomValue } from "jotai/utils";
import { currentUserAtom } from "../jotai/atoms";
import { useSpaceInfo } from "../liveblocks/maps";

export default function ArchiveSpace() {
  const currentUser = useAtomValue(currentUserAtom);
  const [spaceInfo, spaceInfoClient] = useSpaceInfo();

  function archive() {
    spaceInfoClient?.set("archived", true);
  }

  if (
    currentUser &&
    spaceInfo &&
    spaceInfo.owners &&
    spaceInfo.owners.indexOf(currentUser.id) > -1
  )
    return <MenuItem onSelect={archive}>Archive space</MenuItem>;

  return null;
}
